import type { PhilosophyItem } from '../types';
import { DynamicIcon } from './CommonComponents';

interface PhilosophySectionProps {
  items: PhilosophyItem[];
}

export default function PhilosophySection({ items }: PhilosophySectionProps) {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div>
      {/* 标题区域 */}
      <div className="px-4 py-3 border-b border-gray-100 flex items-center">
        <div className="flex items-center gap-2">
          <h3 className="text-base font-bold text-gray-900">企业理念</h3>
          <p className="text-xs text-gray-400 tracking-widest ml-1">CORPORATE PHILOSOPHY</p>
        </div>
      </div>

      {/* 理念列表 */}
      <div className="px-4 pb-4 mt-4 grid grid-cols-2 gap-2">
        {items.map((item, idx) => (
          <div
            key={item.id}
            className="rounded-xl p-3 flex flex-col items-center justify-center"
            style={{
              background: 'linear-gradient(135deg, #f5f9ff 0%, #ffffff 100%)',
            }}
          >
            {/* 图标 */}
            <div
              className="w-12 h-12 flex items-center justify-center mb-1 shadow-sm"
              style={{
                background: item.iconBgColor
                  ? `${item.iconBgColor}20`
                  : 'linear-gradient(135deg, #f5f9ff, #ffffff)',
                borderRadius: '50%',
              }}
            >
              <span style={{ color: item.iconBgColor || '#1c5bff' }}>
                <DynamicIcon
                  iconName={item.icon}
                  className="w-7 h-7 rounded-full"
                />
              </span>
            </div>

            {/* 标题 */}
            {item.title && (
              <h4 className="text-sm font-semibold text-gray-800 mb-0.5">
                {item.title}
              </h4>
            )}

            {/* 英文标题 */}
            {item.titleEn && (
              <p className="text-[10px] text-gray-400 tracking-wider mb-0.5">
                {item.titleEn}
              </p>
            )}

            {/* 描述 */}
            {item.description && (
              <div
                className="text-xs text-gray-600 leading-relaxed rich-text-preview text-center w-full"
                dangerouslySetInnerHTML={{ __html: item.description }}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
